module.exports = __webpack_public_path__ + "img/fashion_106.b23382cc.jpg";